export default __webpack_public_path__ + "static/media/after@3x.a53ac7a8.png";